<script>
    export let metadata;

    function numberToLetters(num) {
        let letters = ''
        while (num >= 0) {
            letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[num % 26] + letters
            num = Math.floor(num / 26) - 1
        }
        return letters
    }

    function getCellIndex(cell) {
        let starting_cell = `${numberToLetters(cell.ci)}${cell.ri+1}`;

        if (cell.range.sci != cell.range.eci || cell.range.sri != cell.range.eri) {
            let ending_cell = `${numberToLetters(cell.range.eci)}${cell.range.eri+1}`;

            starting_cell += `:${ending_cell}`;
        }

        return starting_cell;
    }
</script>

{#if metadata?.type == "cell" && metadata.selected_cell}
<div class="tags has-addons" title={metadata.cell_text}>
    <span class="tag is-light is-success">Excel</span>
    <span class="tag is-light is-info">{metadata.selected_sheet}</span>
    <span class="tag">{getCellIndex(metadata.selected_cell)}</span>
</div>
{:else if metadata?.type == "ppt"}
<div class="tags has-addons">
    <span class="tag is-light is-danger">PPT</span>
    <span class="tag">Slide {metadata.slide_no}</span>
</div>
{/if}